<script lang="ts">
  import type { ClassificationList } from '../types';

  export let items: ClassificationList[];
</script>

<ul class="flex w-full flex-col gap-2 text-base">
  {#each items as item}
    {#if item.name && item.value}
      <li class="flex items-center justify-between">
        <div class="flex-0.4 text-default-600 dark:text-default-500">{item.name}</div>

        <div class="flex-0.7">
          <ul>
            {#each item.value as { name, slug }, index}
              <li class="inline">
                <a
                  class="hover:text-default-600 font-medium transition-colors"
                  href="/artworks/{item.name.toLowerCase()}-{slug}/"
                >
                  {name}{#if index < item.value.length - 1}
                    ,
                  {/if}
                </a>
              </li>
            {/each}
          </ul>
        </div>
      </li>
    {/if}
  {/each}
</ul>
